/**
 * Shared USASpending Detail Components
 *
 * Common components used across recipient and agency detail pages.
 */

export {
  DetailFilterContext,
  DetailFilterProvider,
  useDetailFilter,
  getAvailableFiscalYears,
  toRecipientAnalyticsFilters,
} from './DetailFilterContext'
export type {
  DetailFilterContextValue,
  DetailFilterProviderProps,
} from './DetailFilterContext'

export { SectionCard, SectionSkeleton } from './SectionCard'
export type { SectionCardProps, SectionSkeletonProps } from './SectionCard'

export { KPIStrip, KPICard } from './KPIStrip'
export type { KPIStripProps, KPICardProps } from './KPIStrip'

export { ChartModeToggle } from './ChartModeToggle'

export { TimeRangeToggle, getTimeRangeWindow } from './TimeRangeToggle'
export type { TimeRange } from './TimeRangeToggle'
